import { sb } from '../supabase';

// Every trader conversation, read-only, for /admin2/conversations (owner,
// 2026-10-11): the team gets ONE email when a trader first messages a factory
// or a registered supplier, and follows the rest here.
//
// Two kinds share the `messages` table (src/lib/factoryChat.js:5-7):
//   · factory  — trader -> factory: receiver_id NULL, factory_id set;
//                factory -> trader: receiver_id = trader, factory_id set.
//   · supplier — registered supplier <-> buyer: factory_id NULL, both ids set.
// The admin CANNOT read `messages` directly: its permissive SELECT policy has
// no admin branch, so a plain select returns 0 rows for every thread. Both
// reads go through SECURITY DEFINER RPCs behind is_admin_user()
// (migration 20261016231401). Nothing here writes: an admin must never appear
// inside a private chat.

export async function fetchTraderConversations() {
  const { data, error } = await sb.rpc('admin_trader_conversations');
  if (error) throw error;
  return data || [];
}

export async function fetchConversationMessages({ channel, trader, counterpart }) {
  if (!trader || !counterpart) return [];
  const { data, error } = await sb.rpc('admin_conversation_messages', {
    p_channel: channel === 'factory' ? 'factory' : 'supplier',
    p_trader: trader,
    p_counterpart: counterpart,
  });
  if (error) throw error;
  return data || [];
}

// Which side wrote a message, from the trader's point of view. The trader is
// the sender — on both channels. Testing `receiver_id == null` for factory
// threads was wrong once a factory is claimed: the trader's reply is then
// addressed to the owner (receiver = owner), and showed as the factory's.
export function isFromTrader(m, { trader }) {
  return m.sender_id === trader;
}
